import React from 'react'
import Page from '../../../../../components/Page'
import { useNavigate, useParams } from 'react-router-dom'
import { errorMessage } from '../../../../../hooks/message'
import Swal from 'sweetalert2'
import Service from '../../../../../service'
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

const api = Service.getInstance();

const schema = yup
    .object({
        descricao: yup.string().required('Informe o nome da atividade'),
    })
    .required()

function DetailsTipoAtividade() {

    const { id } = useParams()

    const navigate = useNavigate();

    const [loading, setLoading] = React.useState(false);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            descricao: ''
        },
        resolver: yupResolver(schema)
    })

    React.useEffect(() => {

        if (id) {

            (async () => {

                setLoading(false)

                try {

                    const response = await api.get(`tipo-atividades/${id}`);

                    const { descricao } = response.data;

                    setValue('descricao', descricao);

                } catch (error) {
                    const { message } = errorMessage(error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: message
                    });
                } finally {
                    setLoading(false)
                }

            })();
        }

    }, [id])

    const submit = async (data) => {

        try {

            setLoading(true)

            if (id) {

                await api.put(`tipo-atividades/${id}`, data);

                Swal.fire({
                    icon: 'info',
                    title: 'Sucesso',
                    text: 'Atividade atualizada com sucesso!'
                })

            } else {

                const response = await api.post('tipo-atividades', data);

                const { data: { id: idResponse } } = response.data;

                navigate(`/administracao/tipo-atividades/tipo-atividade/${idResponse}`, { replace: true });

                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'Atividade criada com sucesso!'
                })

            }

        } catch (error) {
            const { message } = errorMessage(error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: message
            })
        } finally {
            setLoading(false)
        }

    }

    return (
        <Page title='Tipo de atividade'>
            <h6 style={{ textTransform: 'uppercase', fontWeight: 'bold' }}>{id ? 'Atualizar tipo de atividade' : 'Cadastrar tipo de atividade'}</h6>
            <form onSubmit={handleSubmit(submit)}>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Descrição da atividade</label>
                    <input type="text" {...register('descricao')} className="form-control form-control-sm" id="exampleInputEmail1" aria-describedby="emailHelp" />
                    <div id="emailHelp" className="form-text text-danger">{errors.descricao?.message}</div>
                </div>
                <div className="d-flex align-items-center">
                    <button type="submit" className={`btn btn-${id ? 'warning' : 'primary'} btn-sm`}>{id ? 'Atualizar' : 'Cadastrar'}</button>
                    {
                        loading && <div className="spinner-grow ms-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    }
                </div>
            </form>
        </Page>
    )
}

export default DetailsTipoAtividade